const API_KEY = 'yDwDRf7wvIUmXTA9jwvE5eHWUKLeykZo';

export const AlchemyOptimismBaseURL = `https://opt-mainnet.g.alchemy.com/v2/${API_KEY}`;
